import { render, staticRenderFns } from "./errorMsg.vue?vue&type=template&id=3db0c79c&scoped=true&name=errorMsg&"
import script from "./errorMsg.vue?vue&type=script&lang=js&"
export * from "./errorMsg.vue?vue&type=script&lang=js&"
import style0 from "./errorMsg.vue?vue&type=style&index=0&id=3db0c79c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0c79c",
  null
  
)

export default component.exports